<template>
<h1 class="page-title">
      {{title}}
</h1>
</template>

<script>
export default {
      name: 'Title',
      props: ["title"]
};
</script>
